import $ from 'jquery';
import AsyncView from 'shopify-asyncview';
import EventHandler from '@pixelunion/events';
import SidebarDrawer from './SidebarDrawer';

let instance = null;

export default class CartMini {
  constructor() {
    if (instance) {
      return instance;
    }

    this.events = new EventHandler();

    instance = this;

    this.data = null;

    this.refresh();
  }

  open() {
    if (!this.data) return;

    SidebarDrawer.open(this.data)
      .then(container => {
        this.events.register(container, 'click', e => {
          if (!e.target.matches('[data-cart-mini-item-remove]')) return;
          this.removeItem(e.target.closest('[data-cart-mini-item]'));
        });
      });
  }

  close() {
    this.events.unregisterAll();
    SidebarDrawer.close();
  }

  removeItem(lineItem) {
    const key = lineItem.dataset.cartMiniItem;
    const url = `${window.Theme.routes.cart_change_url}.js`;
    lineItem.classList.add('cart-mini-item-loading');

    $.post(
      url,
      {
        id: key,
        quantity: 0,
      },
      () => {
        if (document.querySelector('[data-section-id="static-cart"]')) {
          // If we remove an item from minicart while on the cart page,
          // refresh the page to sync cart items on page
          window.location = `${window.Theme.routes.cart_url}`;
        } else {
          this.refresh()
            .done(() => this.open());
        }
      },
      'json',
    );
  }

  refresh() {
    const $deferred = $.Deferred();
    const jsonUrl = `${window.Theme.routes.cart_url}.js`;

    const $deferred1 = $.get(
      jsonUrl,
      data => $('[data-cart-mini-count]').text(data.item_count === 0 ? '' : data.item_count),
      'json',
    );

    const $deferred2 = AsyncView.load(
      window.Theme.routes.cart_url,
      'mini',
    ).done(data => {
      const { header, 'free-shipping-banner': freeShippingBanner, content } = data.html;
      this.data = { header, freeShippingBanner, content };

      return $deferred.resolve();
    }).fail($deferred.reject());

    return $.when($deferred1, $deferred2);
  }
}
